import React from 'react'

const ExtraComp = () => {
  return (
    <>
      <div className="relative text-center py-16 px-10 bg-[#e6f7ff] backdrop-blur-xl">
        <p className="relative text-3xl font-medium text-[#192027]">
          EasyACC - the Preferred Accounting, Billing Software for Small &
          Medium Enterprises!
        </p>
        <p className="relative text-3xl font-medium text-[#192027] mb-10">
          Join with Thousands of our happy customers
        </p>
        <div>
          <a
            href="https://www.easyofficesoftware.com/public/demo/demo/EasyAccDemoSetup.exe"
            rel="noreferrer"
            target="_blank"
            className="sm:px-20 px-6 sm:py-4 bg-black text-white rounded-lg text-2xl font-bold duration-200 transform hover:rounded-full hover:-translate-y-1 transition"
          >
            Download Demo
          </a>
        </div>
      </div>
    </>
  );
}

export default ExtraComp;